export enum SelectionType {
    Single="Single Permit",
    Multiple="Multiple Permit"
}
